module.exports = __webpack_public_path__ + "static/media/bf.348494c4.svg";